import InstantWinDetailCard from "./instantWinDetailCard.container";

export default InstantWinDetailCard;
